/** Pozicije fotografija u receptu (recipe_images.section u Supabaseu). */
export const RECIPE_IMAGE_SECTIONS = [
  {
    value: "main",
    label: "Ispod opisa",
    hint: "Odmah nakon kratkog opisa recepta",
  },
  {
    value: "ingredients",
    label: "Ispod sastojaka",
    hint: "Nakon popisa sastojaka, prije pripreme",
  },
  {
    value: "steps",
    label: "Iznad pripreme",
    hint: "Odmah prije naslova „Priprema”",
  },
];

export const DEFAULT_RECIPE_IMAGE_SECTION = "main";

export function normalizeSection(section) {
  return !section || section === "main" ? "main" : section;
}

export function sortRecipeImages(images = []) {
  return [...images].sort((a, b) => {
    const orderA = a.order != null ? a.order : a.id ?? 0;
    const orderB = b.order != null ? b.order : b.id ?? 0;
    return orderA - orderB;
  });
}

export function imagesInSection(images = [], sectionValue) {
  const key = normalizeSection(sectionValue);
  return sortRecipeImages(images).filter((img) => normalizeSection(img.section) === key);
}

export function splitRecipeImagesBySection(images = []) {
  return {
    main: imagesInSection(images, "main"),
    ingredients: imagesInSection(images, "ingredients"),
    steps: imagesInSection(images, "steps"),
  };
}

export function getNextOrderInSection(images = [], sectionValue) {
  const inSection = imagesInSection(images, sectionValue);
  if (!inSection.length) return 1;
  const maxOrder = inSection.reduce(
    (max, img) => Math.max(max, img.order != null ? img.order : 0),
    0
  );
  return maxOrder + 1;
}

/** Ponovno numerira order (1, 2, 3…) unutar svake sekcije. */
export function renumberSectionOrders(images = []) {
  const result = images.map((img) => ({ ...img }));

  RECIPE_IMAGE_SECTIONS.forEach((section) => {
    const sectionImages = imagesInSection(result, section.value);
    sectionImages.forEach((img, index) => {
      const row = result.find((item) => item.id === img.id);
      if (row) row.order = index + 1;
    });
  });

  return result;
}

export function reorderImageInSection(images, imageId, direction) {
  const target = images.find((img) => img.id === imageId);
  if (!target) return images;

  const section = normalizeSection(target.section);
  const sectionImages = imagesInSection(images, section);
  const index = sectionImages.findIndex((img) => img.id === imageId);
  const swapIndex = direction === "up" ? index - 1 : index + 1;

  if (swapIndex < 0 || swapIndex >= sectionImages.length) return images;

  const swapped = [...sectionImages];
  [swapped[index], swapped[swapIndex]] = [swapped[swapIndex], swapped[index]];

  const orderMap = Object.fromEntries(
    swapped.map((img, idx) => [img.id, idx + 1])
  );

  return images.map((img) =>
    orderMap[img.id] != null ? { ...img, order: orderMap[img.id] } : img
  );
}
